import { currentUser } from "./user";
import { app } from "../firebase";
import { writable } from "svelte/store";
import { handleError } from "../common/error";

let lastUser;
let susbcription;

const db = app.firestore();

export const aboutPages = writable(null);

currentUser.subscribe((user) => {
    if (!user) return closeSubscription();
    if (user.email === (lastUser && lastUser.email) || !user.active) return;
    startSubscription(user);
});

function closeSubscription() {
    lastUser = null;
    aboutPages.set(null);
    if (susbcription) return susbcription();
}

function startSubscription(user) {
    lastUser = user;
    susbcription = db
        .collection("about")
        .orderBy("order")
        .onSnapshot((snapshot) => {
            aboutPages.set(
                snapshot.docs.map((doc) => {
                    const page = doc.data();
                    return {
                        ...page,
                        uid: doc.id,
                    };
                })
            );
        }, handleError);
}

export function saveAboutPage(page) {
    return db.collection("about").doc(page.uid).set(page);
}
